module.exports = __webpack_public_path__ + "img/44.84d2b388.png";